export const validateEmail = email => {
  const emailRegex = /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(.\w{2,3})+$/i;
  return emailRegex.test(email); // initially false and true
};

export const validatePassword = password => {
  return password.length >= 6; // initially false and true
};

export const upperCaseCharValidation = password => {
  const upperCaseCharRegex = /[A-Z]/;
  return upperCaseCharRegex.test(password);
};

export const specialCharValidation = password => {
  const specialCharRegex = /[ !@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/; // eslint-disable-line
  return specialCharRegex.test(password);
};
export const oneNumberValidation = password => {
  const oneNumberRegex = /\d/;
  return oneNumberRegex.test(password);
};

export const pwdEqualValidation = (pwd, confirmPwd) => {
  if (pwd === confirmPwd) return true;
  else return false;
};

export const lowerCaseCharValidation = password => {
  const lowerCaseCharRegex = /[a-z]/;
  return lowerCaseCharRegex.test(password);
};
